import targetIcon from '@/assets/map-markers/target.png';
import pinIcon from '@/assets/map-markers/pin.png';

export default {
    target: targetIcon,
    pin: pinIcon,
};
